import { Component, OnInit, AfterViewInit, ViewChildren } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { AppdataService } from 'src/app/services/services/appdata.service';
import { LoginserviceService } from 'src/app/services/services/loginservice.service';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-addrelievetype',
  templateUrl: './addrelievetype.component.html',
  styleUrls: ['./addrelievetype.component.css']
})
export class AddrelievetypeComponent implements OnInit ,AfterViewInit {

  @ViewChildren('input')firstipcontrol;


  formname:String="RelieveType"; 

//Display
formmode:string="Add";

//Mode Values
isaddmode:boolean=false;
iseditmode:boolean=false;
isdeletemode:boolean=false;
isviewmode:boolean=false;

isloading: boolean = false;
isprivilage: boolean = false;
showProgress: boolean = false;

//Save Validation
submitted:boolean;
successfully:boolean;
saveloading: boolean;

//Edit Get Values
relievetypeColl:any=[];
relievetypeBO:any={};

relievetypeid:number=0

relievetypeform=new FormGroup({
  relievetypeid:new FormControl(0),          
  relievetypename:new FormControl('',Validators.required),  
 inactive:new FormControl(false),  
});


constructor(private appService: AppdataService,private loginService:LoginserviceService,private route: ActivatedRoute,
   public router: Router,private toastr: ToastrService, private productFindService: NgbModal) { 
     this.route.queryParams.subscribe(params => {
       if(params.id!==undefined){
         this.relievetypeid = params.id
       }          
     });

     this.fnServiceChanges();
}

 
fnServiceChanges() {
  this.loginService.serviceAuthChange.subscribe((value) => {
    if (this.loginService.fnCheckCompany()) {
      if (this.fnCheckUserPririvilage()) {
        this.isloading = true;
        this.fnOnInitForm();
      }
      else {
        this.fnUserFailedForm();
      }
    }
    else {
      this.fnUserFailedForm();
    }

  });
}



ngOnInit() {
  try {
    if (this.loginService.fnCheckCompany()) {
      if (this.fnCheckUserPririvilage()) {
        this.isloading = true;
        this.fnOnInitForm();
      }
      else {
        this.fnUserFailedForm();
      }
    }
    else {
      this.loginService.fnGetUserRoleList();
    }

  } catch (ex) {
    this.fnShowErrorMsg(ex);
  }
}

fnOnInitForm() {
   try{
       this.isaddmode=true;
       this.relievetypeform.reset();
       this.fnInitializeFormGroup(); 

       if(this.relievetypeid>0){
         this.fngetRelieveType();
       }
   }catch(ex){
     this.fnShowErrorMsg(ex);
   }
}
fnCheckUserPririvilage() {
  var _check: boolean = false;
  if (this.relievetypeid > 0) {
    _check = this.loginService.fnCheckUserRoleAction(this.formname, 'ALTER')
  } else {
    _check = this.loginService.fnCheckUserRoleAction(this.formname, 'CREATE')
  }

  return _check;
}

fnUserFailedForm() {
  this.isprivilage = true;
}
ngAfterViewInit()
{
  this.loginService.fnSetFirstControlFocus('txtfirst');
}
fnInitializeFormGroup(){
   this.relievetypeform.setValue({
    relievetypeid:0,    
    relievetypename:'',
     inactive:false              
   })
}

//Get 
fngetRelieveType() { 
  if (this.showProgress) {
    return;
  }        
     var data = {
       'relievetypeid':this.relievetypeid,
       'companyid':this.loginService.fnGetCompanyId()          
     }
     this.appService.getRelieveType(data)
     .subscribe(
       (res)=>{                
         if(res.json().status===200){ 
          this.fnHideProgress();
 
           this.relievetypeColl=res.json().result;
           var editdata = this.relievetypeColl[0];        
           this.fnEditMode(editdata);
           this.relievetypeBO=editdata;

         }
         else {
          this.fnHideProgress();

           this.loginService.fnAPIError(res.json())
         }
         
     },
     (err)=>{  
      this.fnHideProgress();
        
       this.toastr.error('Error', err);
     })
}



//Save Btn Click
fnSaveBtnClick(){
   try{ if (this.saveloading) {
    return;
  }

     this.submitted=true;
     this.successfully=false;
     //Validate
     if(this.relievetypeform.valid){ this.saveloading = true;
         //Check
         var data = {
               'relievetypeid': this.relievetypeid,                      
               'relievetypename':this.relievetypeform.get('relievetypename').value, 
               'inactive':this.relievetypeform.get('inactive').value,            
               'companyid':this.loginService.fnGetCompanyId(),
               'createdby': this.loginService.fnGetModUserId(),  
              'modifiedby':this.loginService.fnGetModUserId(),                                                              
         }

       
         this.appService.fnCheckRelieveType(data).subscribe(
           (res)=>{
             if(res.json().status===200){  
               var _checkresult=res.json().result[0].checkfield;
             
               if(_checkresult==="done"){
                     if (this.relievetypeform.get('relievetypeid').value>0){
                       //Update 
                       this.fnSetRelieveType(data);
                     }
                     else{
                       //Insert 
                       this.fnInsertRelieveType(data);
                     }
               }
               else{        
                     if(_checkresult==="name"){ this.saveloading = false;
                       this.relievetypeform.controls['relievetypename'].setErrors({'notfound': true});
                     }
               }
             }
             else { this.saveloading = false;
               this.loginService.fnAPIError(res.json())
             }
         },
         (err)=>{ this.saveloading = false;
             this.toastr.error('Error', err);           
         });
      }
   }catch(ex){ this.saveloading = false;
     this.fnShowErrorMsg(ex);
   }
}

//Insert
fnInsertRelieveType(data){    
 
   this.appService.fnInsertRelieveType(data).subscribe(
     (res)=>{ this.saveloading = false;
       if(res.json().status===200){  
         if(res.json().result!=""){
           this.toastr.success('', "The new relievetype has been added successfully.Insert Successfully");
           this.fnInsertActivityLog('INSERT', 0, data.relievetypname);
           this.fnCloseForm();
         }
       }
       else {
         this.loginService.fnAPIError(res.json())
       }
   },
     (err)=>{ this.saveloading = false;
       this.toastr.error('Error', err);
     });

}

//Set
fnSetRelieveType(data){    

this.appService.fnSetRelieveType(data).subscribe(
 (res)=>{ this.saveloading = false;
   if(res.json().status===200){  
         if(res.json().result!=""){
             this.toastr.success('', "The relievetype has been updated successfully.");
             this.fnInsertActivityLog('EDIT',this.relievetypeid,data.relievetypename);
             this.fnCloseForm();        
         } 
     }
   else {
     this.loginService.fnAPIError(res.json())
   }
 },
 (err)=>{ this.saveloading = false;
   this.toastr.error('Error', err);
 });

}

//Close
fnCloseForm(){
try{
  this.router.navigate(['/RelieveType']);
}catch(ex){
   this.fnShowErrorMsg(ex);
}
}

private fnEditMode(deptBO){
 this.relievetypeform.setValue({ 
  relievetypeid:deptBO.relievetypeid,     
  relievetypename:deptBO.relievetypename,
   inactive:deptBO.inactive
 });

 this.formmode="Edit";
   
 this.iseditmode=true;
 this.isdeletemode=false;
 this.isviewmode=false;
}

fnInsertActivityLog(action,refno,desc){
  try{
    var data={
      logtype:action,
      logat:this.formname,
      refnum:refno,
      logdescr:desc,companyid: this.loginService.fnGetCompanyId(),         
      logby:this.loginService.fnGetModUserId(),
    }
  

    this.appService.fnInsertActivity(data).subscribe(
      (res)=>{
      },
      (err)=>{
     
      });

  }catch{

  }
}
private fnShowProgress() {
  this.showProgress = true;
}
private fnHideProgress() {
  this.showProgress = false;
}
private  fnShowErrorMsg(ex){
this.toastr.warning('Internal Error', ex);       
}









}
